<div class="d-flex analysis-layout">
  <!-- Left Sidebar Navigation -->
  <app-analysis-nav [analysisType]="analysisType" [config]="navConfig"> </app-analysis-nav>

  <!-- Main Content -->
  <div class="content-area">
    <h2>Project Summary Statistics</h2>

    @if (projectViewData) {
      <div>
        <div class="table-actions" role="group" aria-label="Export project summary statistics">
          <button
            class="btn btn-outline-secondary"
            type="button"
            [disabled]="!projectViewData.data.length"
            (click)="copySummaryTable()"
          >
            Copy
          </button>
          <button
            class="btn btn-outline-secondary"
            type="button"
            [disabled]="!projectViewData.data.length"
            (click)="exportSummaryExcel()"
          >
            Excel
          </button>
          <button
            class="btn btn-outline-secondary"
            type="button"
            [disabled]="!projectViewData.data.length"
            (click)="exportSummaryPdf()"
          >
            PDF
          </button>
        </div>
        @if (exportMessage) {
          <p class="export-message" role="status">{{ exportMessage }}</p>
        }
        <div class="global-filter">
          <label class="visually-hidden" for="flairr-summary-global-filter">Search project summary statistics</label>
          <input
            id="flairr-summary-global-filter"
            class="form-control"
            type="search"
            placeholder="Search all columns"
            [value]="globalFilter"
            (input)="onGlobalFilterChange($event, summaryTable)"
          />
        </div>
        <p-table
          #summaryTable
          [value]="projectViewData.data"
          [columns]="projectViewData.cols"
          [filters]="summaryFilters"
          [globalFilterFields]="globalFilterFields"
          (onFilter)="tableUpdateHandler($event)"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="pageSizes"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          class="flairr-summary-table"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (column of columns; track column.data) {
                <th [pSortableColumn]="column.data">
                  <div class="table-header-content">
                    <span class="table-header-title">
                      {{ isReportsColumn(column) ? 'Reports' : column.title }}
                      <p-sortIcon [field]="column.data"></p-sortIcon>
                    </span>
                    @if (!isReportsColumn(column)) {
                      <p-columnFilter
                        [field]="column.data"
                        [type]="isNumericColumn(column) ? 'numeric' : 'text'"
                        display="menu"
                        [showOperator]="true"
                        [showMatchModes]="true"
                        [showAddButton]="true"
                        [filterButtonProps]="filterButtonProps"
                      />
                    }
                  </div>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              @for (column of columns; track column.data) {
                <td>
                  @if (column.data === 'clone_map' && rowData.cloneMapLinks.length > 0) {
                    <div dropdown container="body" placement="bottom left">
                      <button
                        class="btn btn-secondary btn-sm dropdown-toggle"
                        type="button"
                        dropdownToggle
                        aria-haspopup="true"
                        [attr.aria-label]="'Open clone maps for ' + rowData.sample"
                      >
                        <fa-icon [icon]="faTableCells"></fa-icon>
                      </button>
                      <ul *dropdownMenu class="dropdown-menu">
                        @for (link of rowData.cloneMapLinks; track link.dataLink) {
                          <li>
                            <button
                              class="dropdown-item"
                              type="button"
                              [attr.data-link]="link.dataLink"
                              [attr.data-sample]="link.sample"
                              (click)="openCloneMapLink($event)"
                            >
                              {{ link.label }}
                            </button>
                          </li>
                        }
                      </ul>
                    </div>
                  } @else {
                    {{ rowData[column.data] }}
                  }
                </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length || 1">No project summary statistics available.</td>
            </tr>
          </ng-template>
        </p-table>
        <h2>Sample Diversity</h2>
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="flexSwitchCheckDefault"
            [disabled]="!searchActive"
            (change)="onCompareSelectedRows($event)"
          />
          <label class="form-check-label" for="flexSwitchCheckDefault">Compare selected and unselected rows</label>
        </div>
        <div class="row justify-content-md-center">
          @if (shannonPlotData) {
            <div class="col-4">
              <h4>Shannon Entropy</h4>
              <canvas baseChart [data]="shannonPlotData" [options]="chartOptions" [legend]="true" [type]="'violin'">
              </canvas>
            </div>
          }
          @if (simpsonPlotData) {
            <div class="col-4">
              <h4>Simpson Index</h4>
              <canvas baseChart [data]="simpsonPlotData" [options]="chartOptions" [legend]="true" [type]="'violin'">
              </canvas>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
